<template>
  <!--
      	作者：kmdshop
      	时间：2020-06-25
      	描述：插件中心-限时拼团-活动列表
      -->
  <div class="user">
    <!-- <div class="common-form">秒杀活动列表</div> -->
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">发放拼团券</el-button>
    </div>

    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="formInline.status" placeholder="拼团券状态">
            <el-option label="全部" value="-1"></el-option>
            <el-option v-for="(item,index) in status" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.name" placeholder="请输入用户昵称/手机号/用户ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="" label="会员信息">
              <template slot-scope="scope" >
                <div>{{ scope.row.user?scope.row.user.nickName:'' }}</div>
                <div class="gray9">ID：({{ scope.row.user? scope.row.user.user_id:'' }})</div>
              </template>
            </el-table-column>
            <el-table-column prop="type" width="100" label="类型">
              <template slot-scope="scope">
                <div class="orange" v-if="scope.row.type==0">商品抵扣券</div>
                <div class="blue" v-if="scope.row.type==1">金额减免券</div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="商品名称">
              <template slot-scope="scope">
                <div class="" v-if="scope.row.type==0">{{scope.row.assembleproduct.product.product_name}}</div>
                <div class="orange" v-if="scope.row.type==1">不限制</div>
              </template>
            </el-table-column>
            <el-table-column prop="" width="200" label="所属活动">
              <template slot-scope="scope">
                <div class="" v-if="scope.row.type==0">{{scope.row.active.title}}</div>
                <div class="orange" v-if="scope.row.type==1">不限制</div>
              </template>
            </el-table-column>
            <el-table-column prop="" width="100" label="售价/减免金额">
              <template slot-scope="scope">
                <div class="" v-if="scope.row.type==0">{{scope.row.assembleproduct.product.product_price}}</div>
                <div class="orange" v-if="scope.row.type==1">{{scope.row.deduct_price}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="statustext" width="100" label="状态"></el-table-column>
            <!-- <el-table-column prop="create_time" label="发放时间" width="150"></el-table-column> -->
            <el-table-column prop="starttimetext" width="150" label="发放时间"></el-table-column>
            <el-table-column prop="endtimetext" width="150" label="过期时间"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import AssembleApi from '@/api/assemble.js';
  export default {
    components: {},
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        form: {},
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
        formInline: {
          status: '',
          name: '',
        },
        status: ['未使用', '已使用', '已过期','已赠送'],
          file:{},
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        AssembleApi.couponList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {
              self.loading = false;
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*打开添加*/
      addClick() {
        this.$router.push('/plus/assemble/coupon/send');
      },

      /*删除*/
      deleteClick(row) {

        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          AssembleApi.couponDel({
              assemble_coupon_id: row.assemble_coupon_id
            }, true)
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，删除成功',
                  type: 'success'
                });
                //刷新页面
                self.getTableList();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {

            });

        }).catch(() => {});
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/assemble/coupon/index.vue